




























































/* eslint-disable no-unused-vars */
import BaseForm from '@/views/BaseForm';
import { Component } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
// import { userMdl } from '@/models/userMdl';
/* eslint-enable no-unused-vars */

@Component({
    name: 'event_list',
    components: {},
    head: {
        title: {
            inner: 'イベント一覧',
            separator: '-',
            complement: 'Battery-Surveillance',
        },
    },
})
export default class event_list extends BaseForm {
    // ヘッダー情報
    private eventDataHeader: any = [
        { text: '発生日時', align: 'center', value: 'add_date' },
        { text: '機器管理番号', align: 'center', value: 'control_number' },
        { text: '内容', align: 'center', value: 'content', sortable: false },
    ];
    private eventDataList: any = []; // イベントデータ一覧
    private groupListData: any = []; // グループ一覧
    private selectGroup: number = 0; // 選択グループ
    private itemsPerPage: number = 50; // 1ページに表示するアイテム数
    private selectGroupName: string = '';

    async created() {
        await this.getGroupList();
        if (this.groupListData.length > 0) {
            this.selectGroup = this.groupListData[0]['group_id'];
        }
        this.getEventList(this.selectGroup);
    }

    // グループ一覧の取得
    private async getGroupList() {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            const resp: AxiosResponse<any> = await this.$http.post('group_list.php', '', {
                headers: { token: this.token },
            });
            switch (resp.data.result) {
                case 'SUCCESS':
                case 'DATA_NOTFOUND_ERROR':
                    this.groupListData = resp.data.items;
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ取得失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'データ取得失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }

    // イベント一覧の取得
    private async getEventList(selectGroup: number) {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);
            let params: any = { group_id: selectGroup };
            const resp: AxiosResponse<any> = await this.$http.post('event_list.php', params, {
                headers: { token: this.token },
            });
            switch (resp.data.result) {
                case 'SUCCESS':
                case 'DATA_NOTFOUND_ERROR':
                    this.eventDataList = resp.data.items;
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ取得失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'データ取得失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }
}
